
import createIconComponent from '../utils/createIconComponent';
import { SVG_STAR_OUTLINED } from '../../../dist';
import React from 'react';
const StarOutlinedIcon = createIconComponent({ content: SVG_STAR_OUTLINED, height: 24, width: 24 });
StarOutlinedIcon.displayName = 'StarOutlinedIcon';
export default StarOutlinedIcon;
